import { userConstants } from "../../constant";

export function category(state = [], action) {
  switch (action.type) {
    case userConstants.GET_CATEGORY:
      return action.category;

    default:
      return state;
  }
}
